import React from 'react';
import VirtualizedList from '../VirtualizedList';
import styled from 'styled-components';
import WidgetHeader from '../WidgetHeader';
import AnswerComment from './AnswerComment';

function DateTimeWidget({id, answers, sheetsById, question, options}) {

  //Remove this filter once functionality is added to pin dataTimeWidgets
  let filteredOptions = options.filter(option => option.title !== "Pin");

  return (
    <React.Fragment>
      <WidgetHeader id={id} title={question.text} options={filteredOptions}/>
      <ScrollContent>
        <VirtualizedList items={answers.filter(answer => !!answer.value)} defaultHeight={85}>
        {answer => {
          const sheet = sheetsById[answer.sheetId];

          return (
            <AnswerComment sheet={sheet} answer={answer}>
              {new Date(parseInt(answer.value.split(',')[0], 10)).toLocaleString()}
            </AnswerComment>
          );
        }}
        </VirtualizedList>
      </ScrollContent>
    </React.Fragment>
  );
}
const ScrollContent = styled.div`
  height: 39.125rem;
`;

export default React.memo(DateTimeWidget);
